import moment from "moment";

const WEDDING_DATE_TEXT = "2022-05-07";
export const WEDDING_DATE = moment(WEDDING_DATE_TEXT, "YYYY-MM-DD");
export const LAUNCH_DATES = WEDDING_DATE.subtract({ days: 60 });

export const VERT_IMAGE_INDICES = [0, 1, 5, 10, 11, 12, 13, 14, 16, 17];

export { MOBILE_QUERY } from "./stylingQueries";
